import { DropdownMenu, DropdownMenuContent, DropdownMenuItem } from '@herit-fe/heritage-ui';
import type { LucideIcon } from 'lucide-react';
import { ResponsiveDropdownTrigger } from './responsive-dropdown-trigger';

export interface ActionMenuItem {
  key: string;
  label: string;
  onClick: () => void;
  /** leading 아이콘(드롭다운 메뉴아이템은 아이콘 leading 예외). 없으면 텍스트만. */
  icon?: LucideIcon;
  disabled?: boolean;
  /** 파괴적 액션(삭제 등) — destructive 스타일. */
  destructive?: boolean;
}

/**
 * 반응형 액션 메뉴(공통) — `DropdownMenu` + `ResponsiveDropdownTrigger`(pc 라벨+캐럿 / non-pc 아이콘) +
 * 항목 배열 렌더. 여러 액션을 단일 메뉴로 묶어 버튼 과밀·저해상도 배치를 회피하던 동형 패턴(시공 목록·상세)을
 * 공통화. 항목 = `{key,label,onClick,icon?,disabled?,destructive?}`.
 */
export function ActionMenu({
  label,
  icon,
  items,
  align = 'end',
  size = 'default',
}: {
  label: string;
  icon: LucideIcon;
  items: ActionMenuItem[];
  align?: 'start' | 'end';
  size?: 'sm' | 'default';
}) {
  return (
    <DropdownMenu>
      <ResponsiveDropdownTrigger label={label} icon={icon} size={size} />
      <DropdownMenuContent align={align}>
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <DropdownMenuItem
              key={item.key}
              disabled={item.disabled}
              variant={item.destructive ? 'destructive' : 'default'}
              onClick={item.onClick}
            >
              {Icon ? <Icon className="size-4" /> : null}
              {item.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
